import {
  Center,
  Divider,
  Grid,
  GridItem,
  Heading,
  HStack,
  Icon,
  Link,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { Link as RouterLink } from "react-router-dom";

import { Loading } from "src/common/Loading";
import { formatPhoneNumber } from "src/common/phone-numbers";
import theme from "src/common/theme";
import { PageContent } from "src/layout/PageContent";
import {
  PageHeader,
  PageHeaderBackLink,
  PageHeaderTitle,
} from "src/layout/PageHeader";
import { useGetPropertyOrganizationDetails } from "src/routes/Property/queries";

export const Property = () => {
  const query = useGetPropertyOrganizationDetails();

  if (query.isLoading || !query.isSuccess) {
    return <Loading />;
  }

  const propertyData = query.data?.property;
  const dealerData = query.data?.dealer;
  const dealerPointOfContact = dealerData?.pointOfContact;

  return (
    <>
      <PageHeader>
        <PageHeaderBackLink>
          <Link as={RouterLink} to={"/properties"}>
            &#8249; Back to list
          </Link>
        </PageHeaderBackLink>
        <PageHeaderTitle>Property Details</PageHeaderTitle>
      </PageHeader>

      <PageContent>
        <Grid templateColumns={"repeat(2, 1fr)"} gap={4}>
          <GridItem colSpan={1}>
            <Heading display="inline" marginRight={4} size="md">
              Dealer Details
            </Heading>
            <Link
              as={RouterLink}
              to={`/dealers/${dealerData?.dealerOrganizationId}/details`}
            >
              View Dealer
            </Link>
          </GridItem>

          <GridItem colSpan={2}>
            <Divider />
          </GridItem>

          <GridItem>
            <Text>Dealer Name</Text>
          </GridItem>
          <GridItem>
            <Text>{dealerData?.displayName}</Text>
          </GridItem>

          <GridItem>
            <Text>Contact Name</Text>
          </GridItem>
          <GridItem>
            <Text>
              {dealerPointOfContact?.user.firstName}{" "}
              {dealerPointOfContact?.user.lastName}
            </Text>
          </GridItem>

          <GridItem>
            <Text>Contact Phone</Text>
          </GridItem>
          <GridItem>
            <Text>{formatPhoneNumber(dealerPointOfContact?.user.phone)}</Text>
          </GridItem>

          <GridItem>
            <Text>Contact Email</Text>
          </GridItem>
          <GridItem>
            <Text>{dealerPointOfContact?.user.email}</Text>
          </GridItem>
        </Grid>
      </PageContent>

      <PageContent>
        <Grid templateColumns={"repeat(2, 1fr)"} gap={4}>
          <GridItem colSpan={2}>
            <Heading size="md">Property Details</Heading>
          </GridItem>

          <GridItem colSpan={2}>
            <Divider />
          </GridItem>

          <GridItem>
            <Text>Company Name</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.name}</Text>
          </GridItem>

          <GridItem>
            <Text>Property Type</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.propertyType}</Text>
          </GridItem>

          <GridItem>
            <Text>Street Address</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.address}</Text>
          </GridItem>

          <GridItem>
            <Text>City</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.city}</Text>
          </GridItem>

          <GridItem>
            <Text>State</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.state}</Text>
          </GridItem>

          <GridItem>
            <Text>ZIP Code</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.zip}</Text>
          </GridItem>

          <GridItem>
            <HStack>
              <Text>Phone Number</Text>
              <Tooltip
                label="If the “Call a Manager” feature is enabled on your intercom,
            incoming calls will be routed to this number."
              >
                <Center>
                  <Icon
                    color={theme.colors.gray[500]}
                    as={HiQuestionMarkCircle}
                  />
                </Center>
              </Tooltip>
            </HStack>
          </GridItem>
          <GridItem>
            <Text>{formatPhoneNumber(propertyData?.phone)}</Text>
          </GridItem>

          <GridItem>
            <Text>Email</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.email}</Text>
          </GridItem>
        </Grid>
      </PageContent>

      <PageContent>
        <Grid templateColumns={"repeat(2, 1fr)"} gap={4}>
          <GridItem colSpan={2}>
            <Heading size="md">Property Owner Contact Details</Heading>
          </GridItem>

          <GridItem colSpan={2}>
            <Divider />
          </GridItem>

          <GridItem>
            <Text>Property Owner First Name</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.ownerFirstName}</Text>
          </GridItem>

          <GridItem>
            <Text>Property Owner Last Name</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.ownerLastName}</Text>
          </GridItem>

          <GridItem>
            <Text>Property Owner Billing Address</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.ownerAddress}</Text>
          </GridItem>

          <GridItem>
            <Text>Property Owner City</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.ownerCity}</Text>
          </GridItem>

          <GridItem>
            <Text>Property Owner State</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.ownerState}</Text>
          </GridItem>

          <GridItem>
            <Text>Property Owner Zip Code</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.ownerZip}</Text>
          </GridItem>

          <GridItem>
            <Text>Property Owner Email</Text>
          </GridItem>
          <GridItem>
            <Text>{propertyData?.ownerEmail}</Text>
          </GridItem>

          <GridItem>
            <Text>Property Owner Phone</Text>
          </GridItem>
          <GridItem>
            <Text>{formatPhoneNumber(propertyData?.ownerPhone)}</Text>
          </GridItem>
        </Grid>
      </PageContent>
    </>
  );
};
